import { useEffect, useRef } from "react";

export const MasterMeter = ({ engine, height = 120 }) => {
  const bars = [useRef(null), useRef(null)];
  useEffect(() => {
    let raf;
    const tick = () => {
      engine.peaks().forEach((p, i) => {
        const db = p > 0 ? 20 * Math.log10(p) : -60;
        const pct = Math.max(0, Math.min(100, ((db + 60) / 60) * 100));
        if (bars[i].current) {
          bars[i].current.style.height = `${pct}%`;
          bars[i].current.style.background = db > -3 ? "#EF4444" : db > -12 ? "#FFB800" : "#10B981";
        }
      });
      raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [engine]);
  return (
    <div className="flex gap-1" style={{ height }} data-testid="master-meter">
      {bars.map((r, i) => (
        <div key={i} className="w-2.5 bg-[#0B0C10] border border-[#2A2E3D] rounded-sm flex items-end overflow-hidden">
          <div ref={r} className="w-full transition-[height] duration-75" style={{ height: 0 }} />
        </div>
      ))}
    </div>
  );
};
